import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { validateOptionalRequireIf } from '~hooks/reactHookForm';
import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid size={12}>
        <Controller
          name='brand_code'
          defaultValue={''}
          rules={{
            required: 'Dealer Code must be set.',
          }}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='brand_code'
              label='Dealer Code'
              disabled={formSubmitting}
              error={Boolean(errors.brand_code)}
              helperText={errors.brand_code?.message as string | undefined}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='compare_partner_p_number'
          control={control}
          defaultValue={''}
          rules={{
            required: 'Compare Partner P Number is required',
            validate: {
              optionalRequireIf: (value: string) => {
                const validate = validateOptionalRequireIf(value, 'compare_partner_reference_number', getValues);
                return validate ? true : 'Compare Partner P Number is required';
              },
              regex: (value: string) => {
                const pattern = /^[0]\d{9}$/;
                return pattern.test(value) || 'Must be 10 digits numbers starting with 0 with no spaces. eg 0498765437';
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='compare_partner_p_number'
              label='Compare Partner P Number'
              disabled={formSubmitting}
              error={Boolean(errors.compare_partner_p_number)}
              helperText={errors.compare_partner_p_number?.message as string | undefined}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='compare_partner_reference_number'
          control={control}
          defaultValue={''}
          rules={{
            validate: {
              optionalRequireIf: (value: string) => {
                const validate = validateOptionalRequireIf(value, 'compare_partner_p_number', getValues);
                return validate ? true : 'Compare Partner Reference Number is required';
              },
              regex: (value: string) => {
                const pattern = /^\d{7}$/;
                return (
                  pattern.test(value) || 'Compare Partner Reference Number must be numeric and seven characters long.'
                );
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='compare_partner_reference_number'
              label='Compare Partner Reference Number'
              disabled={formSubmitting}
              error={Boolean(errors.compare_partner_reference_number)}
              helperText={errors.compare_partner_reference_number?.message as string | undefined}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name='customer_full_name'
          control={control}
          defaultValue={''}
          rules={{
            required: 'Customer Full Name is required.',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='customer_full_name'
              label='Customer Full Name (first and last name)'
              disabled={formSubmitting}
              error={Boolean(errors.customer_full_name)}
              helperText={errors.customer_full_name?.message as string | undefined}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
